<div class="ng-autocomplete" [ngClass]="{ 'em-has-error': error }">
  <ng-autocomplete
    [data]="data"
    [initialValue]="selectedValue"
    [searchKeyword]="keyword"
    (selected)="selectEvent($event)"
    (inputChanged)="onChangeSearch($event)"
    (inputFocused)="onFocused($event)"
    (inputCleared)="onCleared($event)"
    [itemTemplate]="itemTemplate"
    [notFoundTemplate]="notFoundTemplate"
    [placeholder]="'Material Number'"
    [isLoading]="isLoading"
    [debounceTime]="700"
  >
  </ng-autocomplete>
</div>
<div
  class="em-c-field__note"
  [ngClass]="{ 'em-has-error': error }"
  *ngIf="error"
>
  {{ error }}
</div>
<ng-template #itemTemplate let-item>
  <a [innerHTML]="item.FullName"></a>
</ng-template>

<ng-template #notFoundTemplate let-notFound>
  <div [innerHTML]="notFound"></div>
</ng-template>
